import { MentionItem } from './Item'
import { MentionList } from './List'

export const Mention = {
  Item: MentionItem,
  List: MentionList,
}
